export enum TemplateFooterBtns {
    CALL_TO_ACTION = 'CALL_TO_ACTION',
    QuICK_REPLY = 'QuICK_REPLY'
}
